import snowballSrc from './assets/images/game/snowball.png';
import snowballSrc1 from './assets/images/game/snowball-falling.png';
import snowballSrc2 from './assets/images/game/snowball-jumping.png';
import stickLeftSrc from './assets/images/game/stick-line-left.png';
import stickRightSrc from './assets/images/game/stick-line-right.png';
import cloudSrc from './assets/images/game/bg/right/cloud.png';
import frontCloudSrc from './assets/images/game/bg/left/front-cloud.png';
import frontCloudSrc0 from './assets/images/game/bg/left/cloud-1-ss-0.png';
import frontCloudSrc1 from './assets/images/game/bg/left/cloud-1-ss-1.png';
import frontCloudSrc2 from './assets/images/game/bg/left/cloud-1-ss-2.png';
import frontCloudSrc3 from './assets/images/game/bg/left/cloud-1-ss-3.png';
import moonSrc from './assets/images/game/bg/left/moon.png';
import bigCloudSrc from './assets/images/game/bg/main/big-cloud.png';
import giftSrc from './assets/images/game/bg/main/gift.png';
import houseSrc from './assets/images/game/bg/main/house.png';
import treeSrc from './assets/images/game/bg/main/tree.png';
import treeStarSrc from './assets/images/game/bg/main/tree-star.png';
import resultShareSrc from './assets/images/ResultBackground.jpg';
import caharcterBodySrc from './assets/images/game/character/body.png';
import caharcterTailSrc1 from './assets/images/game/character/TigerBottom_leftToRight_size_620x210.png';
import caharcterTailSrc2 from './assets/images/game/character/TigerBottom_rightToLeft_size_620x210.png';
import caharcterTailSrc3 from './assets/images/game/character/TigerLeft_bottomToTop_size_310x480.png';
import caharcterTailSrc4 from './assets/images/game/character/TigerLeft_topToBottom_size_310x480.png';
import caharcterTailSrc5 from './assets/images/game/character/TigerLeftBottom_to_rightTop__ss_00_08.png';
import caharcterTailSrc6 from './assets/images/game/character/TigerLeftBottom_to_rightTop__ss_09_16.png';
import caharcterTailSrc7 from './assets/images/game/character/TigerLeftTop_to_rightBottom__ss_00_08.png';
import caharcterTailSrc8 from './assets/images/game/character/TigerLeftTop_to_rightBottom__ss_09_16.png';
import caharcterTailSrc9 from './assets/images/game/character/TigerRight_bottomToTop_size_310x480.png';
import caharcterTailSrc10 from './assets/images/game/character/TigerRight_topToBottom_size_310x480.png';
import caharcterTailSrc11 from './assets/images/game/character/TigerRightBottom_to_leftTop__ss_00_08.png';
import caharcterTailSrc12 from './assets/images/game/character/TigerRightBottom_to_leftTop__ss_09_16.png';
import caharcterTailSrc13 from './assets/images/game/character/TigerRightTop_to_leftBottom__ss_00_08.png';
import caharcterTailSrc14 from './assets/images/game/character/TigerRightTop_to_leftBottom__ss_09_16.png';
import caharcterTailSrc15 from './assets/images/game/character/TigerTopToTop_leftToRight_size_580x350__ss_00_14.png';
import caharcterTailSrc16 from './assets/images/game/character/TigerTopToTop_leftToRight_size_580x350__ss_15_16.png';
import caharcterTailSrc17 from './assets/images/game/character/TigerTopToTop_rightToLeft_size_580x350__ss_00_14.png';
import caharcterTailSrc18 from './assets/images/game/character/TigerTopToTop_rightToLeft_size_580x350__ss_15_16.png';
import caharcterTailSrc19 from './assets/images/game/character/TigerTailSideToSide_ss_00_14.png';
import caharcterTailSrc20 from './assets/images/game/character/TigerTailSideToSide_ss_15_29.png';
import caharcterTailSrc21 from './assets/images/game/character/TigerTailSideToSide_ss_30_40.png';
// TREE DESKTOP
import treeSrcDp01 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00000.png';
import treeSrcDp02 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00001.png';
import treeSrcDp03 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00002.png';
import treeSrcDp04 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00003.png';
import treeSrcDp05 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00004.png';
import treeSrcDp06 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00005.png';
import treeSrcDp07 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00006.png';
import treeSrcDp08 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00007.png';
import treeSrcDp09 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00008.png';
import treeSrcDp10 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00009.png';
import treeSrcDp11 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00010.png';
import treeSrcDp12 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00011.png';
import treeSrcDp13 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00012.png';
import treeSrcDp14 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00013.png';
import treeSrcDp15 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00014.png';
import treeSrcDp16 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00015.png';
import treeSrcDp17 from './assets/images/game/bg/main/tree-desktop/tree-450x600-ss-00016.png';
// TREE MOBILE
import treeSrcMb01 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00000.png';
import treeSrcMb02 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00001.png';
import treeSrcMb03 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00002.png';
import treeSrcMb04 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00003.png';
import treeSrcMb05 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00004.png';
import treeSrcMb06 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00005.png';
import treeSrcMb07 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00006.png';
import treeSrcMb08 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00007.png';
import treeSrcMb09 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00008.png';
import treeSrcMb10 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00009.png';
import treeSrcMb11 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00010.png';
import treeSrcMb12 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00011.png';
import treeSrcMb13 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00012.png';
import treeSrcMb14 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00013.png';
import treeSrcMb15 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00014.png';
import treeSrcMb16 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00015.png';
import treeSrcMb17 from './assets/images/game/bg/main/tree-mobile/tree-450x600-ss-00016.png';

import { serviceWorkerRegister } from './js/sw';
import { Base } from './js/base';

// import { ee } from './js/eventEmitter';

const progressValueStart = 15;
const progress = {
    value: 0,
    progressValueElement: document.getElementById('progressValue'),

    get progressValue() {
        return this.value;
    },

    set progressValue(val) {
        this.value = val;
        this.progressValueElement.innerHTML = Math.round(val).toString(10);
    }
};

const contentLoaded = (jsImagesStoreArr) => {
    progress.progressValue = 100;
    const preloader = document.querySelector('.preloader');
    const main = document.querySelector('.main');
    const mainLayout = document.getElementById('mainLayout');
    const startPage = document.getElementById('startPage');

    preloader.classList.toggle('preloader_done');

    // eslint-disable-next-line
    const base = new Base(jsImagesStoreArr);

    setTimeout(() => {
        // preloader animate
        main.classList.toggle('main_active');
        mainLayout.classList.add('main-layout_active');
        startPage.classList.add('start-page_active');
    }, 500);
};

const loadResources = async () => {
    const w = window.innerWidth;
    const h = window.innerHeight;

    // 21 images
    const tailImagesSrc = [
        caharcterTailSrc1,
        caharcterTailSrc2,
        caharcterTailSrc3,
        caharcterTailSrc4,
        caharcterTailSrc5,
        caharcterTailSrc6,
        caharcterTailSrc7,
        caharcterTailSrc8,
        caharcterTailSrc9,
        caharcterTailSrc10,
        caharcterTailSrc11,
        caharcterTailSrc12,
        caharcterTailSrc13,
        caharcterTailSrc14,
        caharcterTailSrc15,
        caharcterTailSrc16,
        caharcterTailSrc17,
        caharcterTailSrc18,
        caharcterTailSrc19,
        caharcterTailSrc20,
        caharcterTailSrc21
    ];
    // 17 images
    const treeImagesSrc = (w <= 425 || h <= 425)
        ? [
            treeSrcMb01,
            treeSrcMb02,
            treeSrcMb03,
            treeSrcMb04,
            treeSrcMb05,
            treeSrcMb06,
            treeSrcMb07,
            treeSrcMb08,
            treeSrcMb09,
            treeSrcMb10,
            treeSrcMb11,
            treeSrcMb12,
            treeSrcMb13,
            treeSrcMb14,
            treeSrcMb15,
            treeSrcMb16,
            treeSrcMb17
        ]
        : [
            treeSrcDp01,
            treeSrcDp02,
            treeSrcDp03,
            treeSrcDp04,
            treeSrcDp05,
            treeSrcDp06,
            treeSrcDp07,
            treeSrcDp08,
            treeSrcDp09,
            treeSrcDp10,
            treeSrcDp11,
            treeSrcDp12,
            treeSrcDp13,
            treeSrcDp14,
            treeSrcDp15,
            treeSrcDp16,
            treeSrcDp17
        ];
    // 14 images
    let imagesSrc = [
        snowballSrc,
        snowballSrc1,
        snowballSrc2,
        stickLeftSrc,
        stickRightSrc,
        cloudSrc,
        frontCloudSrc,
        frontCloudSrc0,
        frontCloudSrc1,
        frontCloudSrc2,
        frontCloudSrc3,
        moonSrc,
        bigCloudSrc,
        giftSrc,
        houseSrc,
        treeSrc,
        treeStarSrc,
        caharcterBodySrc
    ];

    const jsImagesManifest = [{ src: resultShareSrc, id: 'ResultBackground' }];

    imagesSrc = imagesSrc.concat(treeImagesSrc).concat(tailImagesSrc);

    // create images
    const jsImages = jsImagesManifest.map(({ id, src }) => ([id, { src, id, image: new Image() }]));
    const images = imagesSrc.map(() => new Image());

    // set src on images
    // jsImagesSrc.forEach((src, index) => { jsImages[index].src = src; });
    // imagesSrc.forEach((src, index) => { images[index].src = src; });
    const delta = (100 - progressValueStart) / (jsImages.length + images.length);

    const promiseArray = images.map((image, index) => new Promise((resolve) => {
        const handler = () => {
            progress.progressValue += delta;
            resolve();
        };

        image.onload = handler;
        image.onerror = handler;

        image.src = imagesSrc[index];
    }));

    const promiseArrayTail = jsImages.map((arr) => new Promise((resolve) => {
        const [, item] = arr;
        const handler = () => {
            progress.progressValue += delta;
            resolve();
        };

        item.image.onload = handler;
        item.image.onerror = (e) => {
            item.error = true;
            item.errorEvent = e;
            handler();
        };

        item.image.src = item.src;
    }));

    await Promise.all(promiseArray);
    await Promise.all(promiseArrayTail);

    return Object.fromEntries(new Map(jsImages));
};

function setWindowHeight() {
    const cssParams = `--start-page-height: ${window.innerHeight}px`;

    document.documentElement.style.cssText = cssParams;
}

const loadDone = async () => {

    setWindowHeight();

    console.log('Assets loading finished');

    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        serviceWorkerRegister();
    }

    progress.progressValue = progressValueStart;

    const jsImagesStoreArr = await loadResources();

    // ee.emit('loadDone');
    contentLoaded(jsImagesStoreArr);
};

window.addEventListener('load', loadDone);
